import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const Container = ({ children , className , 'data-t': dataT  })=>/*#__PURE__*/ React.createElement("div", swcHelpers.extends({
        className: classnames('container', className)
    }, dataT && {
        'data-t': dataT
    }), children)
;

export { Container as default };
//# sourceMappingURL=Container.js.map
